import { Button, Card } from "flowbite-react";
import { FaCheckCircle } from "react-icons/fa";
import { useState } from "react";
import SurveyCustomer from "./SurveyCustomer";
import SurveyVehicle from "./SurveyVehicle";
import SurveyChecklist from "./SurveyChecklist";
import SurveyPhoto from "./SurveyPhoto";
import { useLocation } from "react-router-dom";
import SurveyReview from "./SurveyReview";
import SurveySuccess from "./SurveySuccess";

const Survey = ({ title, message }) => {
  const location = useLocation();
  const surveyReceived = location.state;
  const [survey, setSurvey] = useState(null);
  const [surveyVehicle, setSurveyVehicle] = useState(null);
  const [surveyChecklist, setSurveyChecklist] = useState([]);
  const [surveyResponses, setSurveyResponses] = useState([]);
  const [activeStep, setActiveStep] = useState(1);
  const [pdfSurvey, setPdfSurvey] = useState(null);

  useState(async () => {
    if (surveyReceived) {
      setSurvey(surveyReceived);

      if (surveyReceived.SurveyVehicle) {
        let surveyVehicle = {};
        surveyVehicle.vehicle = surveyReceived.SurveyVehicle;
        setSurveyVehicle(surveyVehicle);
      }

      if (surveyReceived?.responses?.length > 0) {
        setSurveyChecklist(
          surveyReceived?.responses?.map((response) => response.id)
        );
        setSurveyResponses(surveyReceived?.responses);
      }
    }
  }, []);

  return (
    <Card className="mb-3 flex-1 card-survey">
      <ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
        <li className="flex md:w-full items-center text-primary dark:text-blue-500 sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {activeStep >= 1 ? (
              <FaCheckCircle color="green" className="mr-2" />
            ) : (
              <span className="me-2">1</span>
            )}
            <span className="hidden md:block">Dados</span>
          </span>
        </li>
        <li className="flex md:w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {activeStep >= 2 ? (
              <FaCheckCircle color="green" className="mr-2" />
            ) : (
              <span className="me-2">2</span>
            )}
            <span className="hidden md:block">Veículo</span>
          </span>
        </li>
        <li className="flex md:w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {activeStep >= 3 ? (
              <FaCheckCircle color="green" className="mr-2" />
            ) : (
              <span className="me-2">3</span>
            )}
            <span className="hidden md:block">Imagens</span>
          </span>
        </li>
        <li className="flex md:w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
          <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500">
            {activeStep >= 4 ? (
              <FaCheckCircle color="green" className="mr-2" />
            ) : (
              <span className="me-2">4</span>
            )}
            <span className="hidden md:block">Checklist</span>
          </span>
        </li>
        <li className="flex items-center">
          {activeStep === 5 ? (
            <FaCheckCircle color="green" className="mr-2" />
          ) : (
            <span className="me-2">5</span>
          )}
          <span className="hidden md:block">Visualizar</span>
        </li>
      </ol>

      {activeStep === 1 && (
        <SurveyCustomer
          setActiveStep={setActiveStep}
          survey={survey}
          setSurvey={setSurvey}
        />
      )}

      {activeStep === 2 && (
        <SurveyVehicle
          surveyVehicle={surveyVehicle}
          setSurveyVehicle={setSurveyVehicle}
          survey={survey}
          setActiveStep={setActiveStep}
        />
      )}

      {activeStep === 3 && (
        <SurveyPhoto setActiveStep={setActiveStep} survey={survey} />
      )}

      {activeStep === 4 && (
        <SurveyChecklist
          setActiveStep={setActiveStep}
          survey={survey}
          setSurveyChecklist={setSurveyChecklist}
          surveyChecklist={surveyChecklist}
          surveyResponses={surveyResponses}
        />
      )}

      {activeStep === 5 && (
        <SurveyReview
          surveyChecklist={surveyChecklist}
          survey={survey}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          setPdfSurvey={setPdfSurvey}
        />
      )}

      {activeStep === 6 && <SurveySuccess pdfSurvey={pdfSurvey} />}
    </Card>
  );
};

export default Survey;
